import type { ReactNode, FormEvent } from 'react'

interface SearchCardProps {
  children: ReactNode
  onSubmit: (e: FormEvent) => void
  /** Le pagine non ancora migrate passano filtri con classi Bootstrap col-md-*, che richiedono il parent "row g-3". Le pagine migrate impostano true e usano classi Tailwind (es. md:col-span-*) sui figli. */
  tailwindGrid?: boolean
}

export function SearchCard({ children, onSubmit, tailwindGrid }: SearchCardProps) {
  return (
    <div className="mb-4 rounded-xl border border-border bg-canvas p-4 shadow-sm">
      <form onSubmit={onSubmit} className={tailwindGrid ? 'grid grid-cols-1 gap-3 md:grid-cols-12 md:items-end' : 'row g-3'}>
        {children}
      </form>
    </div>
  )
}
